import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-item-location',
  standalone: false,
  templateUrl: './item-location.component.html',
  styleUrl: './item-location.component.scss',
})
export class ItemLocationComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('locationMapContainer', { static: true })
  locationMapContainer!: ElementRef<HTMLDivElement>;

  @HostListener('window:resize')
  onResize() {
    this.locationMap?.invalidateSize();
  }

  @Input() latitude!: number;
  @Input() longitude!: number;

  @Input() icon?: L.Icon;

  @Input() zoom = 6;

  private syriaBounds = L.latLngBounds([32.3, 35.6], [37.3, 42.4]);

  private locationMap!: L.Map;
  private marker?: L.Marker;

  ngAfterViewInit(): void {
    this.initializeMap();
    this.renderMarker();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.locationMap && (changes['latitude'] || changes['longitude'] || changes['icon'])) {
      this.renderMarker();
    }
  }

  ngOnDestroy(): void {
    if (this.locationMap) {
      this.locationMap.remove();
      this.locationMap = undefined as any;
    }
  }

  private initializeMap(): void {
    if (this.locationMap) return;

    this.locationMap = L.map(this.locationMapContainer.nativeElement, {
      maxBounds: this.syriaBounds,
      maxBoundsViscosity: 1.0, // prevents dragging outside
      minZoom: 6.5, // prevents zooming too far out
      maxZoom: 18,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
    }).addTo(this.locationMap);
  }

  private renderMarker(): void {
    if (!this.longitude || !this.latitude) return;

    const latLng = L.latLng(this.latitude, this.longitude);

    if (this.marker) {
      this.locationMap.removeLayer(this.marker);
    }

    this.marker = L.marker(latLng, {
      icon: this.icon ?? this.getDefaultIcon(),
    }).addTo(this.locationMap);

    this.locationMap.setView(latLng, this.zoom);
  }

  private getDefaultIcon(): L.Icon {
    return L.icon({
      iconUrl: 'icons/map-point.png',
      iconRetinaUrl: 'icons/map-point.png',
      shadowUrl: 'icons/map-point.png',
      iconSize: [18, 18],
      iconAnchor: [10, 7],
      shadowSize: [18, 18],
    });
  }
}
